module.exports = __webpack_public_path__ + "static/media/pe.5ddb3d59.svg";